import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getCityLocationAndVerifySpecialties} from '../../services/getCityLocationAndVerifySpecialties';
import {GetCityLocationAndVerifySpecialtiesParams} from '../../services/getCityLocationAndVerifySpecialties/types';

function useGetCityLocationAndVerifySpecialtiesQuery(
	params: GetCityLocationAndVerifySpecialtiesParams,
) {
	return useQuery({
		queryKey: [QUERY_KEYS.CITY_LOCATION_AND_VERIFY_SPECIALTIES, params],
		queryFn: ({signal}) => getCityLocationAndVerifySpecialties({signal, ...params}),
		enabled: Boolean(params.latitude && params.longitude),
		staleTime: 0,
		gcTime: 0,
	});
}

export {useGetCityLocationAndVerifySpecialtiesQuery};
